var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.candidate)?_c('div',{staticClass:"content"},[_vm._m(0)]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('span',{staticClass:"description"},[_c('strong',[_vm._v("Das Lebenslauf-Feature wird zur Zeit überarbeitet. In der Zwischenzeit können Sie die Nutzer im Chat nach einem Lebenslauf fragen. Wir entschuldigen uns für die Umstände.")])])])])
}]

export { render, staticRenderFns }